module.exports = __webpack_public_path__ + "static/img/bank-account-graphic.b0e3ff4f.svg";